import { simplePost } from 'api'

export const sendGoogleReserveConversionData = (rwgToken, merchantChanged) => {
    const body = {
        conversion_partner_id: window.GOOGLE_PARTNER_ID,
        rwg_token: rwgToken,
        merchant_changed: merchantChanged,
    }

    return simplePost(window.GOOGLE_RESERVE_CONVERSION_URL, body, {
        'Content-Type': 'application/json',
    }).catch()
}
